export default __webpack_public_path__ + "static/media/phoneme2.810a041f.png";